import { motion } from "framer-motion";
import { IMAGES } from "@/lib/constants";
import { CarWatermark } from "./Watermark";

const EASE = [0.16, 1, 0.3, 1];

const REASONS = [
  { n: "01", title: "Avaliação honesta", desc: "Avaliação profissional para identificar a real necessidade do veículo." },
  { n: "02", title: "Orçamento antes", desc: "Apresentamos os serviços necessários antes da execução." },
  { n: "03", title: "Equipamentos", desc: "Equipamentos e ferramentas profissionais para diagnóstico e manutenção." },
  { n: "04", title: "Transparência", desc: "O veículo é acompanhado durante o serviço e você recebe informações sobre tudo o que foi encontrado." },
];

const STRUCTURE = [
  "Mecânica Geral", "Suspensão", "Freios", "Balanceamento", "Geometria",
  "Troca de Óleo", "Diagnóstico Eletrônico", "Ar-Condicionado", "Auto Elétrica", "Revisões Preventivas",
];

export const About = () => (
  <section id="sobre" className="py-20 lg:py-28 bg-ink">
    <div className="px-4 sm:px-6 lg:px-10 max-w-[1400px] mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
      >
        <p className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-gray-500 mb-6">
          <span className="text-signal">05</span>
          <span className="h-px w-10 bg-signal/60" />
          Por que a MW Auto Center
        </p>
        <h2 className="font-display font-black uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-white max-w-4xl">
          Mais do que trocar peças. <span className="text-signal">Nós avaliamos o seu carro.</span>
        </h2>
      </motion.div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {REASONS.map((r, i) => (
          <motion.div
            key={r.n}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: EASE }}
            className="border border-white/[0.08] bg-card p-6"
          >
            <span className="font-mono text-xs text-signal">{r.n}</span>
            <h3 className="mt-3 font-display font-bold uppercase text-xl text-white">{r.title}</h3>
            <p className="mt-2 text-sm text-gray-400 leading-relaxed">{r.desc}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="relative mt-14 mx-auto max-w-3xl"
      >
        <img
          src={IMAGES.workshop}
          alt="Carro em revisão no elevador da MW Auto Center"
          loading="lazy"
          className="w-full h-[420px] sm:h-[560px] object-cover object-[50%_40%] border border-white/[0.08]"
        />
        <span className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.3em] text-volt bg-ink/90 px-4 py-2">
          ● Revisão periódica
        </span>
      </motion.div>

      <div className="relative mt-24 overflow-hidden">
        <CarWatermark className="-left-24 -top-8 w-[42rem] -rotate-2" flip />
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="relative flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6"
        >
          <div>
            <p className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-gray-500 mb-6">
              <span className="text-signal">06</span>
              <span className="h-px w-10 bg-signal/60" />
              Nossa Estrutura
            </p>
            <h2 className="font-display font-black uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-white max-w-2xl">
              Estrutura completa para <span className="text-signal">cuidar do seu carro.</span>
            </h2>
          </div>
          <p className="text-sm sm:text-base text-gray-400 leading-relaxed max-w-sm lg:text-right">
            Uma oficina completa no Centro de Balneário Camboriú, preparada para
            atender o seu veículo do início ao fim.
          </p>
        </motion.div>

        <div className="relative mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {STRUCTURE.map((item, i) => (
            <motion.div
              key={item}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 5) * 0.06, ease: EASE }}
              className="border border-white/[0.08] bg-card p-5 hover:border-signal/40 transition-colors duration-300"
            >
              <span className="font-mono text-[10px] text-volt">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-2 font-display font-bold uppercase text-lg text-white leading-tight">{item}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
